import { render } from "./DemoSettings.vue?vue&type=template&id=233653bb"
import script from "./DemoSettings.vue?vue&type=script&lang=js"
export * from "./DemoSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__